import { useDispatch, useSelector } from 'react-redux';
import { TApplicationState } from '../../libs/store';
import { TGlobalSearchDynamicState } from '../../../../../../shared/frontend/scripts/global-search/store/types';
import { useEffect } from 'react';
import { generateSearchDynamicKeyByParams } from '../../../../../../shared/frontend/scripts/global-search/utils';
import { apiServiceAsync } from '../../services/apiService';
import { TAction } from '../../../../../../shared/frontend/scripts/actions/types/action';
import { globalSearchActions } from '../../../../../../shared/frontend/scripts/global-search/store/modules';

const DEFAULT_STATE: TGlobalSearchDynamicState = {
  data: null,
  error: false,
  loaded: false,
  loading: false
};

export const useDynamicGlobalSearch = (params: any) => {
  const dispatch = useDispatch();
  const key = generateSearchDynamicKeyByParams(params);

  const stateByKey = useSelector((state: TApplicationState) => state.globalSearch.dynamic) as Record<
    string,
    TGlobalSearchDynamicState
  >;

  const state = stateByKey[key] || DEFAULT_STATE;

  useEffect(() => {
    if (!state.loaded) {
      dispatch(globalSearchActions.fetchDynamicByParams(params));
    }
  }, [key]);

  return state;
};

export const generateDynamicGlobalSearchPreloadActions = async (params: any): Promise<TAction<any>[]> => {
  const result: TAction<any>[] = [];

  try {
    const data = await apiServiceAsync.searchAdvanced(params);
    result.push(
      globalSearchActions.setDynamicStateByParams(params, { data, loaded: true, loading: false, error: false })
    );
  } catch (error) {
    result.push(
      globalSearchActions.setDynamicStateByParams(params, { data: null, loaded: true, loading: false, error })
    );
  }

  return result;
};
